import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { MdKeyboardArrowLeft, MdKeyboardDoubleArrowRight, MdKeyboardArrowRight } from "react-icons/md";
import ReactPaginate from 'react-paginate'; 
import _constantUtil from '../../../utils/Constant'; 

function ViewBets() { 
    const navigate = useNavigate() 

    return (
        <div className="px-4">
            <div className="container-fluid p-0">
                <div className="row">
                    <div className="d-flex align-items-center justify-content-between">
                        <h4 className="header-title pb-3 text-muted mt-3 mb-0">
                            <Link onClick={() => navigate(-2)}
                                className="header-sub-title">
                                Launched Match
                            </Link>
                            <span className="blr-player-view">
                                <MdKeyboardDoubleArrowRight className="jumbo-red-text mb-1 ms-2" />
                            </span>
                            <Link onClick={() => navigate(-1)} className="header-sub-title">
                                All Bets
                            </Link>
                            <span className="blr-player-view">
                                <MdKeyboardDoubleArrowRight className="jumbo-red-text mb-1 ms-2" />
                            </span>
                            View Bets
                        </h4>
                        <div className="d-flex align-items-center my-3">
                            <button
                                type="button"
                                className="btn text-white d-flex"
                                style={{ float: "right" }}
                                onClick={() => navigate(-1)}
                            >
                                <MdKeyboardArrowLeft className="fs-4" />
                                Back
                            </button>
                        </div>
                    </div>

                    <div className="col-12">
                        <div className="card w-100 bets-responsive">
                            <div className="card-body pb-0">
                                <div className="ps-2 d-flex justify-content-center">
                                    <div className='mb-3'>
                                        <b>Question :</b> <span> Who will win the match ? </span>
                                    </div>
                                </div>
                                <div
                                    className="d-flex align-items-center justify-content-around"
                                    style={{
                                        borderTop: "1px solid var(--bs-border-color)",
                                        borderBottom: "0px",
                                        overflowX: "auto",
                                        whiteSpace: "nowrap"
                                    }}>
                                    <h6
                                        className="w-50 ms-2 mb-0 py-3 text-center"
                                        style={{ borderRight: "1px solid var(--bs-border-color)" }} >
                                        Label: &nbsp;
                                        <span className="badge badge-primary-lighten fs-6 me-2">
                                            IPS/LIV 
                                        </span>
                                    </h6>
                                    <h6
                                        className="w-50 ms-2 mb-0 py-3 text-center"
                                        style={{ borderRight: "1px solid var(--bs-border-color)" }} >  State: &nbsp;
                                        <span className="badge badge-info-lighten">INREVIEW</span> 
                                    </h6>
                                    <h6 className="w-50 ms-2 mb-0 py-3 text-center">
                                        Result: &nbsp;
                                        <span className="badge badge-primary-lighten fs-6 me-2">
                                             instant 
                                        </span>
                                    </h6>
                                </div>
                            </div>
                        </div>

                        <div className="card mt-3">
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table id="scroll-horizontal-datatable" className="table w-100">
                                        <thead>
                                            <tr>
                                                <th>SN</th>
                                                <th>Username</th>
                                                <th className='text-nowrap'>Bet Amount</th>
                                                <th>Rate</th>
                                                <th>Payout</th>
                                                <th className='text-nowrap'>Selected Option</th>
                                                <th>Result</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>1</td>
                                                <td className='text-nowrap'>Jay<br />(jay@gmail.com)</td>
                                                <td>
                                                    <span className="badge badge-info-lighten"> 100</span>
                                                </td>
                                                <td>
                                                    <span className="badge badge-danger-lighten"> 2.2</span>
                                                </td>
                                                <td>
                                                    <span className="badge badge-warning-lighten">220</span>
                                                </td>
                                                <td>Yes</td>
                                                <td>
                                                    <span className="badge badge-warning-lighten">
                                                        pending
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <ReactPaginate
                                    className='pagination' 
                                    previousLabel={<MdKeyboardArrowLeft className='fs-4' />}
                                    nextLabel={<MdKeyboardArrowRight className='fs-4' />}
                                    breakLabel={'...'}
                                    containerClassName={'pagination-container'}
                                    activeClassName={'pagination-active-page'}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ViewBets;
